import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '../tokens/environment.token';
import * as i0 from "@angular/core";
export class UrlService {
    constructor(environment) {
        this.environment = environment;
        this.baseUrl = '/proxy';
        this.portalUrl = '/';
        if (this.environment.production) {
            this.baseUrl =
                window.ContextConfig?.sdpRestUrl ||
                    'https://developmicroservices.dev.qtsdatacenters.com/sdp';
            this.portalUrl =
                window.ContextConfig?.portalUrl ||
                    'https://develop.dev.qtsdatacenters.com/portal';
        }
    }
    //Api Service Url
    get serviceDeskUrl() {
        return `${this.baseUrl}/api/service-desk/v1`;
    }
    get serviceDeskV2Url() {
        return `${this.baseUrl}/api/service-desk/v2`;
    }
    get rosterV1Url() {
        return `${this.baseUrl}/api/roster/v1`;
    }
    get rosterUrl() {
        return `${this.baseUrl}/roster/v2`;
    }
    get orderingUrl() {
        return `${this.baseUrl}/ordering/v1`;
    }
    get orderingV2Url() {
        return `${this.baseUrl}/ordering/v2`;
    }
    get uiOrdering() {
        return `${this.baseUrl}/ui/ordering`;
    }
    get auxiliaryUrl() {
        return `${this.baseUrl}/api/auxiliary/v1`;
    }
    get dashboardV1Url() {
        return `${this.baseUrl}/api/dashboard/v1`;
    }
    get commonV1Url() {
        return `${this.baseUrl}/api/common/v1`;
    }
    get securityAdminV1Url() {
        return `${this.baseUrl}/api/security-admin/v1`;
    }
    // Roster Service Urls
    get userContextUrl() {
        return `${this.rosterUrl}/api/user_context`;
    }
    // Suxiliary Service Urls
    get auxiliaryQualtrics() {
        return `${this.auxiliaryUrl}/qualtrics`;
    }
    get qualtricsUserData() {
        return `${this.auxiliaryQualtrics}/q_userdata`;
    }
    get userInfoUrl() {
        return `${this.rosterUrl}/api/user_info`;
    }
    get getSpaceCategoriesUrl() {
        return `${this.rosterUrl}/api/space-categories`;
    }
    get getSpaceCategoriesReadersUrl() {
        return `${this.getSpaceCategoriesUrl}/readers`;
    }
    get getSpaceCategoriesReaderUrl() {
        return `${this.getSpaceCategoriesUrl}/reader`;
    }
    get getspaceCategoriesAvailableUrl() {
        return `${this.getSpaceCategoriesUrl}/available`;
    }
    get getSpacePermittedServiceAttributesUrl() {
        return `${this.uiOrdering}/permitted_service_attributes`;
    }
    static { this.ɵfac = function UrlService_Factory(t) { return new (t || UrlService)(i0.ɵɵinject(ENVIRONMENT)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UrlService, factory: UrlService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [ENVIRONMENT]
            }] }], null); })();
